import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe4a283e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "PLUS(PPD)", -1))
const _hoisted_5 = { class: "table table-bordered plusmetric-summary plus-metric-print" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    scope: "row",
    class: "heading"
  }, "PLUS PPD Summary")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Target", -1))
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Actual", -1))
const _hoisted_10 = { class: "font-weight-bold" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Difference", -1))
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-9" }, null, -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "plusmetrics-payperiod-grid-container" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Pay Period", -1))
const _hoisted_20 = { class: "plusmetrics-payperiod-grid" }
const _hoisted_21 = { class: "table table-bordered plusmetric-summary plus-metric-print" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Target"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Actual"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Difference")
  ])
], -1))
const _hoisted_24 = { class: "target-hours-col" }
const _hoisted_25 = { class: "actual-hours-col" }
const _hoisted_26 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_27 = { class: "plusmetric-monthly-grid-container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Entire Month", -1))
const _hoisted_29 = { class: "plusmetrics-payperiod-grid" }
const _hoisted_30 = { class: "table table-bordered plusmetric-summary plus-metric-print" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} })
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Target"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Actual"),
    /*#__PURE__*/_createElementVNode("th", { class: "heading" }, "Difference")
  ])
], -1))
const _hoisted_33 = { class: "target-hours-col" }
const _hoisted_34 = { class: "actual-hours-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.plusMetricsReportInput.plusMetricsPayPeriod != null && _ctx.plusMetricsReportInput.plusMetricsPayPeriod.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("tbody", null, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plusMetricsReportInput.plusMetricsPayPeriod, (totalMetricRecord, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: totalMetricRecord }, [
                    (index == (_ctx.plusMetricsReportInput.plusMetricsPayPeriod.length - 1))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("tr", null, [
                            _hoisted_7,
                            _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.getFixedNumber(totalMetricRecord.targetHours)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_9,
                            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.getFixedNumber(totalMetricRecord.actualHours)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_11,
                            _createElementVNode("td", _hoisted_12, [
                              (totalMetricRecord.varianceHours < 0)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: ['fas', 'arrow-circle-down'],
                                    size: "1x"
                                  }))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: ['fas', 'arrow-circle-up'],
                                    size: "1x"
                                  })),
                              _createTextVNode(" " + _toDisplayString(_ctx.getFixedNumber(totalMetricRecord.varianceHours)), 1)
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.facilityName + ' > ' + _ctx.departmentName), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("table", _hoisted_21, [
                  _hoisted_22,
                  _hoisted_23,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plusMetricsReportInput.plusMetricsPayPeriod, (metricRecord, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: metricRecord }, [
                        _createElementVNode("td", null, [
                          (index == (_ctx.plusMetricsReportInput.plusMetricsPayPeriod.length - 1))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Total")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.getPayPeriodDate(metricRecord.date)), 1)
                              ], 64))
                        ]),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(metricRecord.targetHours), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(metricRecord.actualHours), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(['difference-hours-col', _ctx.getNegativeNumberClass(metricRecord.varianceHours)])
                        }, _toDisplayString(_ctx.formatNegativeNumbers(metricRecord.varianceHours)), 3)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.plusMetricsReportInput.plusMetricsMonth != null && _ctx.plusMetricsReportInput.plusMetricsMonth.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("table", _hoisted_30, [
                      _hoisted_31,
                      _hoisted_32,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plusMetricsReportInput.plusMetricsMonth, (metricRecord, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: metricRecord }, [
                            _createElementVNode("td", null, [
                              (index == (_ctx.plusMetricsReportInput.plusMetricsMonth.length - 1))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("Total")
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.getPayPeriodDate(metricRecord.date)), 1)
                                  ], 64))
                            ]),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(metricRecord.targetHours), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(metricRecord.actualHours), 1),
                            _createElementVNode("td", {
                              class: _normalizeClass(['difference-hours-col', _ctx.getNegativeNumberClass(metricRecord.varianceHours)])
                            }, _toDisplayString(_ctx.formatNegativeNumbers(metricRecord.varianceHours)), 3)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}